import type { AppDefinition } from '../../../../types/apps';

const denialDefinition: AppDefinition = {
  appId: 'phys-denial',
  name: 'Denial Code Lookup',
  version: '1.0.0',
  description:
    'CARC & RARC denial/remark code lookup — plain-language explanations, next steps, and appeal guidance.',

  entityTypes: [],
  requiresEntity: false,
  requiresProps: false,
  preserveAppInstance: true,

  component: 'phys-denial',

  icon: {
    type: 'phosphor' as const,
    phosphorIcon: 'Warning',
    phosphorWeight: 'duotone' as const,
    metadata: {
      source: 'app' as const,
      appId: 'phys-denial',
      isAppIcon: true,
    },
  },

  agenticToolIds: ['physician_widget'],
  features: [],
  category: 'physician',
  isCore: false,
  isSystem: true,
  hidden: true,
};

export default denialDefinition;
